class Color {
    readonly RED = 'rgba(244, 67, 54, 0.82)'
    readonly GREEN = 'rgba(7, 232, 51, 0.74)'
    readonly WARNING = 'rgba(255, 106, 0, 0.69)'
    readonly GRAY = 'rgba(191, 191, 191, 0.82)'
}

export const COLOR = new Color()